import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMicrophone = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12.143 2.267a2.276 2.276 0 0 0-2.286 2.267V10.2a2.276 2.276 0 0 0 2.286 2.267 2.276 2.276 0 0 0 2.285-2.267V4.534a2.276 2.276 0 0 0-2.285-2.267ZM7.57 4.534C7.571 2.03 9.618 0 12.143 0s4.571 2.03 4.571 4.534V10.2c0 2.504-2.046 4.533-4.571 4.533s-4.572-2.03-4.572-4.533V4.534Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M4.143 9.067c.631 0 1.143.508 1.143 1.134a6.77 6.77 0 0 0 2.008 4.808 6.886 6.886 0 0 0 4.849 1.992 6.886 6.886 0 0 0 4.849-1.992A6.773 6.773 0 0 0 19 10.201c0-.626.512-1.134 1.143-1.134s1.143.508 1.143 1.134a9.03 9.03 0 0 1-2.678 6.411 9.182 9.182 0 0 1-6.465 2.656 9.182 9.182 0 0 1-6.465-2.656A9.03 9.03 0 0 1 3 10.201c0-.626.512-1.134 1.143-1.134Zm2.286 13.601c0-.626.511-1.133 1.142-1.133h9.143c.632 0 1.143.507 1.143 1.133s-.511 1.134-1.143 1.134H7.571a1.138 1.138 0 0 1-1.142-1.134Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12.143 17.001c.631 0 1.143.508 1.143 1.134v4.533c0 .626-.512 1.134-1.143 1.134A1.138 1.138 0 0 1 11 22.668v-4.533c0-.626.512-1.134 1.143-1.134Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMicrophone);
export default ForwardRef;
